export const notificationTypes = {
  USER_INFO: 'USER_INFO',
  USER_ADDED_FREE_AD: 'USER_ADDED_FREE_AD',
  USER_ADDED_PAID_AD: 'USER_ADDED_PAID_AD',
  USER_MUST_CREATE_PASSWORD: 'USER_MUST_CREATE_PASSWORD',
  DISCOUNT_CARD_ACTIVATED: 'DISCOUNT_CARD_ACTIVATED'
}
